export default __webpack_public_path__ + "static/media/todo.6713a8d4.svg";